export default __webpack_public_path__ + "static/media/case_placeholder.d84fa432.png";